import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { APP_PATHS } from '../routes/paths';
import apiService from '../services/api.service';

export const useEmailSubmit = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (isSubmitting || !email) return;

    setIsSubmitting(true);

    try {
      const response = await apiService.createOnboarding({ email });
      const onboardingId = response.data.id;

      navigate(APP_PATHS.onboarding, { state: { email, onboardingId } });
    } catch (error) {
      console.error('Failed to create onboarding:', error);
      // Still navigate even if API fails - form will create new record on submit
      navigate(APP_PATHS.onboarding, { state: { email } });
    } finally {
      setIsSubmitting(false);
    }
  };

  return { email, setEmail, handleSubmit, isSubmitting };
};
